module.exports = __webpack_public_path__ + "static/media/dailykos_story_2016_6_11_1537582_-The-most-thorough-profound-and-moving-defense-of-Hillary-Clinton-I-have-ever-seen_plot.132fd626.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/dailykos_story_2016_6_11_1537582_-The-most-thorough-profound-and-moving-defense-of-Hillary-Clinton-I-have-ever-seen_plot.png
// module id = 386
// module chunks = 0